import React, { ReactNode, useState } from 'react'
import usePortal from './usePortal'
import { createPortal } from 'react-dom'
import { Fade } from './animation'

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface IModalConfirmConfig {}

interface IResult {
  name: string
  value: string
  description?: string
}

export interface IReportData {
  type: 'confirm' | 'cancel'
  data: IResult[]
}

interface IProps {
  visible: boolean
  config?: IModalConfirmConfig
  onButtonClick?: (data: IReportData) => void
}

/**
 * 评论举报弹框
 */
const ModalReport = ({ visible, config, onButtonClick }: IProps) => {
  const target = usePortal('__modal-report')
  const reportConfig = [
    {
      name: '淫秽色情',
      value: '304',
    },
    {
      name: '营销广告',
      value: '302',
    },
    {
      name: '恶意谩骂攻击',
      value: '312',
    },
    {
      name: '我有话说',
      value: '315',
    },
  ]

  const [checkedValue, setCheckedValue] = useState<IResult>({
    name: '淫秽色情',
    value: '304',
  })
  const [description, setDescription] = useState('')

  const handleConfirmClick = () => {
    onButtonClick &&
      onButtonClick({
        type: 'confirm',
        data: [
          {
            name: checkedValue.name,
            value: checkedValue.value,
            description,
          },
        ],
      })
  }

  const handleCancelClick = () => {
    onButtonClick &&
      onButtonClick({
        type: 'cancel',
        data: [],
      })
  }

  const handleResultChange = (e: any) => {
    setCheckedValue({
      name: e.currentTarget.id,
      value: e.currentTarget.value,
    })
  }

  const handleResultExtraChange = (e: any) => {
    setDescription(e.currentTarget.value)
  }

  const stopPropagation = (e: any) => {
    e.stopPropagation()
  }

  const render = (): ReactNode => {
    return (
      <>
        <Fade in={visible} timeout={200} unmountOnExit>
          <div className="modal-confirm-wrap" onClick={handleCancelClick}>
            <div className="modal-confirm" onClick={stopPropagation}>
              <div className="title">举报此人</div>
              <div className="content">
                {reportConfig.map((reportItem, reportIndex) => {
                  return (
                    <div
                      className={'result-wrap'}
                      key={`result-${reportIndex}`}
                    >
                      <input
                        type="radio"
                        name="report-result"
                        value={reportItem.value}
                        id={reportItem.name}
                        checked={checkedValue.value === reportItem.value}
                        onChange={handleResultChange}
                      />
                      <label htmlFor={reportItem.name}>{reportItem.name}</label>
                    </div>
                  )
                })}
              </div>

              {checkedValue.value === '315' ? (
                <div className="input-wrap">
                  <textarea
                    name="result-extra"
                    id="result-extra"
                    onChange={handleResultExtraChange}
                  />
                </div>
              ) : null}

              <div className="bottom-wrap">
                <div className="button cancel" onClick={handleCancelClick}>
                  {'取消'}
                </div>
                <div className="button confirm" onClick={handleConfirmClick}>
                  {'确认'}
                </div>
              </div>
            </div>
          </div>
        </Fade>
        <style jsx>
          {`
            .modal-confirm-wrap {
              position: fixed;
              top: 0;
              bottom: 0;
              left: 0;
              right: 0;
              z-index: 1024;
              width: 100%;
              height: 100%;
              background-color: rgba(0, 0, 0, 0.6);
            }
            .modal-confirm {
              width: 420px;
              background-color: #ffffff;
              box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.2);
              position: absolute;
              top: 50%;
              left: 50%;
              transform: translate3d(-50%, -50%, 0);
              padding: 28px;
              display: flex;
              flex-direction: column;
              justify-content: space-between;
            }

            .title {
              font-size: 16px;
              color: #1a1a1a;
              line-height: 1.5;
              font-weight: bold;
              user-select: none;
            }

            .content {
              margin-top: 24px;
            }

            .content .result-wrap {
              display: flex;
              align-items: center;
              font-size: 14px;
              color: #1a1a1a;
              line-height: 1.57;
              margin-bottom: 12px;
            }

            .content .result-wrap input {
              width: 14px;
              height: 14px;
            }

            .content .result-wrap label {
              padding-left: 5px;
              user-select: none;
            }

            .input-wrap textarea {
              width: 100%;
              height: 72px;
              font-size: 14px;
              padding: 10px;
              color: #1a1a1a;
              border: 1px solid #e9e9e9;
              outline: none;
            }

            .bottom-wrap {
              display: flex;
              flex-direction: row;
              justify-content: flex-end;
              margin-top: 18px;
            }

            .button {
              width: 72px;
              height: 36px !important;
              border-radius: 4px;
              border: solid 1px #cccccc;
              cursor: pointer;
              font-size: 16px;
              color: #1a1a1a;
              display: flex;
              justify-content: center;
              align-items: center;
              user-select: none;
              margin-left: 16px;
            }

            .confirm {
              background-color: #ffe100;
              color: #1a1a1a;
              border: none;
            }
          `}
        </style>
      </>
    )
  }

  if (!visible) {
    return null
  }

  return createPortal(render(), target)
}

export default ModalReport
